import React, { useState } from 'react';
import { Modal, Rate, Input } from 'antd';
import { message } from '../services/toastMessage';
import { useTranslation } from 'react-i18next';
import { createReview } from '../services/ReviewService';
import { IReview } from '../interfaces/heavyDutyMachinery/IReview';
import { TRANSLATIONS } from '../constants/translations';
import { translate } from '../helpers/translationHelper';

const { TextArea } = Input;

interface ReviewModalProps {
  bookingId: string;
  open: boolean;
  onClose: () => void;
  onSubmitted: (review: IReview) => void;
}

const ReviewModal: React.FC<ReviewModalProps> = ({ bookingId, open, onClose, onSubmitted }) => {
  const { t } = useTranslation();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleClose = () => {
    setRating(0);
    setComment('');
    onClose();
  };

  const handleSubmit = async () => {
    if (rating < 1) {
      message.error(translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_REVIEW_RATING_REQUIRED));
      return;
    }
    setSubmitting(true);
    try {
      const review = await createReview({ bookingId: Number(bookingId), rating, comment: comment.trim() || undefined });
      message.success(translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_REVIEW_SUBMIT_SUCCESS));
      onSubmitted(review);
      handleClose();
    } catch (error: any) {
      message.error(error.message || translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_REVIEW_SUBMIT_ERROR));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title={translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_REVIEW_MODAL_TITLE)}
      open={open}
      onCancel={handleClose}
      onOk={handleSubmit}
      okText={translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_REVIEW_SUBMIT_BUTTON)}
      confirmLoading={submitting}
    >
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8 }}>{translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_REVIEW_RATING_LABEL)}</div>
        <Rate value={rating} onChange={setRating} />
      </div>
      <div>
        <div style={{ marginBottom: 8 }}>{translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_REVIEW_COMMENT_LABEL)}</div>
        <TextArea
          rows={4}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder={translate(t, TRANSLATIONS.HEAVY_DUTY_MACHINERY_REVIEW_COMMENT_PLACEHOLDER)}
          maxLength={1000}
        />
      </div>
    </Modal>
  );
};

export default ReviewModal;
